import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CobrandingFixedHeader as theme } from 'legacy/css-modules';

class CobrandingFixedHeader extends PureComponent {
  state = {
    visible: false
  };

  static propTypes = {
    contentTopId: PropTypes.string.isRequired
  };

  vrContentTop = null;
  ticking = false;

  componentDidMount() {
    this.vrContentTop = document.getElementById(this.props.contentTopId);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleVisibleState = () => {
    const { visible } = this.state;
    if (visible && window.scrollY < this.vrContentTop.offsetTop) {
      this.setState({ visible: false });
    } else if (!visible && window.scrollY >= this.vrContentTop.offsetTop) {
      this.setState({ visible: true });
    }
    this.ticking = false;
  };

  handleScroll = () => {
    if (!this.ticking) {
      window.requestAnimationFrame(this.handleVisibleState);
      this.ticking = true;
    }
  };

  render() {
    const { cobrandingData } = this.props;
    const { visible } = this.state;
    return (
      <div
        className={classNames(theme.outer, {
          [theme.visible]: visible
        })}
      >
        <div className={theme.content}>
          {cobrandingData.photoUrl && (
            <div>
              <div
                className={theme['user-photo']}
                style={{ backgroundImage: `url(${cobrandingData.photoUrl})` }}
              />
            </div>
          )}
          <div className={theme['user-name']}>{cobrandingData.fullName}</div>
        </div>
      </div>
    );
  }
}

export default CobrandingFixedHeader;
